import React from "react";
import classNames from "classnames";

import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function AllocationsList({ allocations }: Props) {
  return (
    <div className={styles.allocationsList}>
      {allocations.slice(0, 2).map(({ resource }) => (
        <li key={resource.uuid} className={styles.allocation}>
          <ResourceAvatar resource={resource} />
        </li>
      ))}
      {allocations.slice(2).length > 0 && (
        <li className={classNames(styles.allocation, styles.summary)}>
          <p>+{allocations.slice(2).length}</p>
        </li>
      )}
    </div>
  );
}

export { AllocationsList };
